import React, { useState, useEffect } from "react";
import { Form, Input, Button, message } from "antd";
import { useSearchParams, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import { API_BASE_URL } from "../api/api";

const ResetPasswordPage = () => {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const email = searchParams.get("email");
  const code = searchParams.get("code");

  useEffect(() => {
    if (!email || !code) {
      message.error("Invalid or missing parameters.");
      navigate("/forgot-password");
    }
  }, [email, code, navigate]);

  const onFinish = async (values) => {
    if (values.password !== values.confirmPassword) {
      message.warning("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}resetPassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          code,
          password: values.password,
        }),
      });

      const data = await res.json();
      if (res.ok && data.success) {
        message.success("Password reset successful. Please log in.");
        navigate("/");
      } else {
        message.error(data.error || "Failed to reset password.");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #eef2f3, #8e9eab)",
        padding: 20,
      }}
    >
      <div
        style={{
          width: 420,
          padding: "48px 36px",
          background: "#fff",
          borderRadius: 18,
          boxShadow: "0 14px 40px rgba(0,0,0,0.1)",
          textAlign: "center",
        }}
      >
        <img
          src={logo}
          alt="CRM Logo"
          style={{ width: 90, marginBottom: 20 }}
        />
        <h2 style={{ marginBottom: 6, fontWeight: 600, fontSize: 24 }}>
          Set New Password
        </h2>
        <p style={{ marginBottom: 28, color: "#666" }}>
          Create a new password for your account
        </p>

        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="New Password"
            name="password"
            rules={[{ required: true, message: "Please enter a password" }]}
          >
            <Input.Password placeholder="New password" />
          </Form.Item>

          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            rules={[
              { required: true, message: "Please confirm your password" },
            ]}
          >
            <Input.Password placeholder="Confirm password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Reset Password
            </Button>
          </Form.Item>
        </Form>

        <div style={{ fontSize: 12, color: "#aaa", marginTop: 30 }}>
          © {new Date().getFullYear()} Sunbook.ca · All rights reserved
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
